import { createBasicLocation, ILocation } from "src/router/routeTypes"

const AiAssistant = createBasicLocation("/ai-assistant")

const AiAssistantKnowledge = createBasicLocation(
  `${AiAssistant.location().pathname}/knowledge`
)

const AiAssistantKnowledgeContent: ILocation<{
  contextId: string
  suggestionId?: string | null
}> = {
  location({ contextId, suggestionId }) {
    const pathname = `${AiAssistantKnowledge.location().pathname}/${contextId}`

    const searchParams = new URLSearchParams()

    if (suggestionId) {
      searchParams.set("suggestion_id", suggestionId)
    }

    return { pathname, search: searchParams.toString() }
  },
} as const

export const AiAssistantRoutes = {
  AiAssistant,
  AiAssistantKnowledge,
  AiAssistantKnowledgeContent,
} as const
